import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApiConfig } from '@/config/api.config';
import { useAxiosAuth } from '@/hooks/useAxiosAuth';
import type { UpdateAppAiSettingsDto } from '../types/app-ai-settings.types';

export const useAppAiSettingsUpdateMutation = (onSuccess?: () => void) => {
    const axiosInstance = useAxiosAuth();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (body: UpdateAppAiSettingsDto) => {
            await axiosInstance.put(ApiConfig.queries.superAdmin.aiSettings.endpoints.update, body);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [ApiConfig.queries.superAdmin.aiSettings.queryKeys.get],
            });
            onSuccess?.();
        },
    });
};
